import { useEffect, useState } from 'react';

import {
  fetchScoutDownloads,
  getScoutDownloadPlatform,
  type ScoutDownload,
  type ScoutDownloadPlatform,
} from '../helpers/scout-download';

type ScoutDownloadState =
  | { status: 'loading'; platform: ScoutDownloadPlatform }
  | { status: 'ready'; downloads: ScoutDownload[] }
  | { status: 'error'; platform: ScoutDownloadPlatform }
  | { status: 'unsupported' };

export function useScoutDownload(): ScoutDownloadState {
  const [state, setState] = useState<ScoutDownloadState>(() => {
    const platform = getScoutDownloadPlatform();
    return platform ? { status: 'loading', platform } : { status: 'unsupported' };
  });

  useEffect(() => {
    if (state.status !== 'loading') return;

    const controller = new AbortController();
    const platform = state.platform;

    void fetchScoutDownloads(platform, controller.signal)
      .then((downloads) => setState({ status: 'ready', downloads }))
      .catch((error: unknown) => {
        if (error instanceof DOMException && error.name === 'AbortError') return;
        setState({ status: 'error', platform });
      });

    return () => controller.abort();
  }, [state]);

  return state;
}
